var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9875 0.5C6.0875 0.5 0.5 6.1 0.5 13C0.5 19.9 6.0875 25.5 12.9875 25.5C19.9 25.5 25.5 19.9 25.5 13C25.5 6.1 19.9 0.5 12.9875 0.5ZM13 23C7.475 23 3 18.525 3 13C3 7.475 7.475 3 13 3C18.525 3 23 7.475 23 13C23 18.525 18.525 23 13 23ZM12.725 6.75H12.65C12.15 6.75 11.75 7.15 11.75 7.65V13.55C11.75 13.9875 11.975 14.4 12.3625 14.625L17.55 17.7375C17.975 17.9875 18.525 17.8625 18.775 17.4375C18.8378 17.3363 18.8795 17.2235 18.8978 17.1058C18.916 16.9881 18.9104 16.8679 18.8813 16.7525C18.8521 16.637 18.8 16.5286 18.728 16.4337C18.6561 16.3387 18.5658 16.2593 18.4625 16.2L13.625 13.325V7.65C13.625 7.15 13.225 6.75 12.725 6.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time_icon.8e3542bf22edc459e626d1f6e6e0c49e.svg";
export { ForwardRef as ReactComponent };